<div class="esign-event-viewing-completed" *transloco="let t">
	<op-masthead [title]="t('ESIGN.EVENT.VIEWING_COMPLETED.title')"></op-masthead>
	<op-content-container class="content">
		<span [innerHTML]="t('ESIGN.EVENT.VIEWING_COMPLETED.message')"></span>
	</op-content-container>
</div>
